module.exports = __webpack_public_path__ + "static/media/img1-3.4ef4811f.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/manzano/biosense/diff/img1-3.png
// module id = 1735
// module chunks = 3